import { Injectable } from "@angular/core";
import {MftAllowListHttpDataService} from "@mft/default-dashboard/services/mft-allow-list-http-data.service";
import {map, Observable, of, switchMap, tap} from "rxjs";
import {MftAllowLists} from "@mft/default-dashboard/models/mft-allow-lists.model";
import {UserSettings, UserSettingsService} from "@feature/user-settings";

@Injectable({ providedIn: 'root' })
export class MftAllowListDataService {

  mftAllowLists: MftAllowLists;

  constructor(
    private readonly httpService: MftAllowListHttpDataService,
    private readonly userSettings: UserSettingsService
  ) { }

  public getForCurrentUser(): Observable<MftAllowLists> {
    return this.userSettings.getUserSettings().pipe(
      switchMap((userSettings: UserSettings) => {
        // re-query every time if we're in preview mode
        // otherwise previous allow lists for a different entity are potentially returned
        // causing the invalid entity page
        if (this.mftAllowLists === undefined || userSettings.IsInPreviewMode) {
          return this.httpService.getForCurrentUser().pipe(
            tap((data: MftAllowLists) => {
              this.mftAllowLists = data;
            }),
            map(x => x)
          );
        } else {
          return of(this.mftAllowLists);
        }
      }));
  }
}
